import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';
import { DateCalculationService } from './date-calculation.service';


@Injectable({
  providedIn: 'root'
})
export class SupervisionService {


  constructor(private http: HttpClient, private dateService: DateCalculationService, private tokenService : TokenService) { }

  /**
   * Fonction test appel serveur
   */
  testWebService() {
    const httpHeaders = this.tokenService.loadToken();
    return this.http.post('/api/traitement/test',{}, {headers: httpHeaders});
  }

  getVolumetrie() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/supervision/volumetrie-traitees";

    return this.http.get(request, {headers : httpHeaders});
  }


  /***
   * Fonction recuperation Donneee Fiche PTL Recues
   */
  getDataGrapheFicheRecues(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/getReportingFicheRecue';
    console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }
  //fin du fichier



  getListeFichesRecues(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-recues/?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);

    return this.http.get(request, {headers : httpHeaders});
  }


  getListeFichesTraitees(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-traitees/?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);

    return this.http.get(request, {headers : httpHeaders});
  }

  getListeKoEnAttenteRetour(dateDebut : string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/reporting/liste-fiches-ko-attente?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);

    return this.http.get(request, {headers : httpHeaders});
  }

  getTauxIsoMensuel() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/supervision/iso-mensuel";

    return this.http.get(request, {headers : httpHeaders});
  }

  getTauxIsoHebdo() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/supervision/iso-hebdo";

    return this.http.get(request, {headers : httpHeaders});
  }


  getDelai() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/supervision/delai";

    return this.http.get(request, {headers : httpHeaders});
  }


  /***
   * Fonction recuperation Donneee Fiche PTL A Traiter J
   */
  getDataGrapheFicheATraiterJ(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-volume-fiche-restante-j';
    console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }

  /***
   * Fonction recuperation Donneee Fiche PTL A Traiter J + 1
   */
  getDataGrapheFicheATraiterJPlusUn(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-volume-fiche-restante-a-traiter';
    console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }

  /***
   * Fonction recuperation Donneee Fiche PTL TRAITER J
   */
  getDataGrapheFicheTraiterJ(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-volume-fiche-deja-traiter';
    console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }

  /**
   * Fonction recuperation donnee suivi global En temps Reel JOUR J
   * @param objEnvoi
   */
  getSuiviPerformanceGlobalTemps(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-suivi-performance-global-en-temps-reel';
    //console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }

  /***
   * Fonction recuperation donnee suivi gglobal Mensuel
   * @param objEnvoi
   */
  getSuiviPerformanceGlobalMensuel(objEnvoi: any) {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-suivi-mensuel-performance-global';
    //console.log(objEnvoi);
    return this.http.post(request, objEnvoi, {headers : httpHeaders});
  }

  /***
   * Fonction recuperation stock en cours
   */
  getNbStockEC() {
    const httpHeaders = this.tokenService.loadToken();
    const request = '/api/supervision/get-stock-encours';
    //console.log(objEnvoi);
    return this.http.post(request, {}, {headers : httpHeaders});
  }
}

